"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var WrapTableActions_1 = require("../../../../../../shared/components/table_actions/WrapTableActions");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var ToolBarButtonsOnly_1 = require("../../../../../../shared/components/toolbars/ToolBarButtonsOnly");
var TableActionMinus_1 = require("../../../../../../shared/components/table_actions/TableActionMinus");
var TableActionPlus_1 = require("../../../../../../shared/components/table_actions/TableActionPlus");
var ButtonLockLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockLockAll");
var ButtonLockUnLockAll_1 = require("../../../../../../shared/components/buttons/ButtonLockUnLockAll");
var TableCheckActionIconSelect_1 = require("../../../../../../shared/components/table_actions/TableCheckActionIconSelect");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var TableActionEdit_1 = require("../../../../../../shared/components/table_actions/TableActionEdit");
var ToolBarComboBoxFilter_1 = require("../../../../../../shared/components/toolbars/ToolBarComboBoxFilter");
var TableActionConfig_1 = require("../../../../../../shared/components/table_actions/TableActionConfig");
var ButtonDoCalc_1 = require("../../../../../../shared/components/buttons/ButtonDoCalc");
var TableActionRobot_1 = require("../../../../../../shared/components/table_actions/TableActionRobot");
var GameSetGamesList = /** @class */ (function (_super) {
    __extends(GameSetGamesList, _super);
    function GameSetGamesList(props) {
        var _this = _super.call(this, props) || this;
        _this.searchTitleInput = null;
        _this.state = {
            data: [],
            filters: [],
            loading: true,
            totalRows: 0,
            searchTitleFilter: [],
            searchTitleValue: ""
        };
        return _this;
    }
    GameSetGamesList.prototype.componentWillMount = function () {
        var _this = this;
        this.SID = this.props.data.Subscribe("*", function (id, data) {
            _this.setState({
                data: data.data,
                totalRows: data.total,
                filters: data.groups_filter,
                loading: false
            });
        });
        this.props.data.LoadData(this.props.record.key, this.props.allCurrency, this.props.currencyId);
        //<div style={{ marginLeft: "5px" }}>Набор: [{this.props.record.title}]</div>
        this.props.state.setExtBreadCrumbPath(["\u0421\u043F\u0438\u0441\u043E\u043A \u0438\u0433\u0440: [" + this.props.record.title + "]"]);
    };
    GameSetGamesList.prototype.componentWillUnmount = function () {
        this.props.data.UnSubscribe(this.SID);
    };
    GameSetGamesList.prototype.componentWillReceiveProps = function (nextProps) {
        if (nextProps) {
            if (nextProps.record.key != this.props.record.key) {
                nextProps.data.LoadData(nextProps.record.key, nextProps.allCurrency, nextProps.currencyId);
            }
        }
    };
    GameSetGamesList.prototype.onClearTitleFilter = function () {
        this.setState({ searchTitleFilter: [], searchTitleValue: "" });
    };
    GameSetGamesList.prototype.onChangeTitleFilter = function (e) {
        this.setState({ searchTitleValue: e.target.value });
    };
    GameSetGamesList.prototype.onConfirmTitleFilter = function () {
        this.setState({ searchTitleFilter: [this.state.searchTitleValue] });
    };
    GameSetGamesList.prototype.DoAllowGame = function (rec) {
        if (rec.is_allowed) {
            this.props.data.SetGameTemplateIsRejected({
                brand_gameset_id: rec.brand_gameset_id,
                gameprovider_game_id: rec.gameprovider_game_id
            });
        }
        else {
            this.props.data.SetGameTemplateIsAllowed({
                brand_gameset_id: rec.brand_gameset_id,
                gameprovider_game_id: rec.gameprovider_game_id
            });
        }
    };
    GameSetGamesList.prototype.DoUpOrder = function (rec) {
        this.props.data.doPlustGameTemplatePriority({
            brand_gameset_id: rec.brand_gameset_id,
            gameprovider_game_id: rec.gameprovider_game_id
        }, 1);
    };
    GameSetGamesList.prototype.DoDownOrder = function (rec) {
        this.props.data.doPlustGameTemplatePriority({
            brand_gameset_id: rec.brand_gameset_id,
            gameprovider_game_id: rec.gameprovider_game_id
        }, -1);
    };
    GameSetGamesList.prototype.doSetFreeSpinLines = function (rec) {
        var _this = this;
        this.props.dlgNumericEditor
            .SetTitle("Изменить кол-во линий")
            .SetDigitsCountValue(0)
            .SetInputCaption("Кол-во линий")
            .SetInputPlaceHolder("Введите кол-во линий")
            .SetMaxValue(rec.game_lines_count)
            .SetMinValue(0)
            .SetValue(rec.fs_lines)
            .SetOnCloseClick(function () { _this.props.dlgNumericEditor.Close(); })
            .SetOnYesClick(function (val) {
            _this.props.data.doSetGameFreeSpinLines({
                gameprovider_gameset_game_id: rec.key_uid,
                app_currency_id: _this.props.currencyId
            }, val);
        }).Show();
    };
    GameSetGamesList.prototype.doSetFreeSpinMultiplier = function (rec) {
        var _this = this;
        this.props.dlgNumericEditor
            .SetTitle("Изменить множитель")
            .SetDigitsCountValue(0)
            .SetInputCaption("Множитель")
            .SetInputPlaceHolder("Введите значение множителя")
            .SetMaxValue(999)
            .SetMinValue(0)
            .SetValue(rec.fs_mult)
            .SetOnCloseClick(function () { _this.props.dlgNumericEditor.Close(); })
            .SetOnYesClick(function (val) {
            _this.props.data.doSetGameFreeSpinMultiplier({
                gameprovider_gameset_game_id: rec.key_uid,
                app_currency_id: _this.props.currencyId
            }, val);
        }).Show();
    };
    GameSetGamesList.prototype.doSetFreeSpinBet = function (rec) {
        var _this = this;
        this.props.dlgNumericEditor
            .SetTitle("Изменить ставку")
            .SetDigitsCountValue(2)
            .SetInputCaption("Ставка")
            .SetInputPlaceHolder("Введите значение ставки")
            .SetMaxValue(999)
            .SetMinValue(0)
            .SetValue(rec.fs_bet)
            .SetOnCloseClick(function () { _this.props.dlgNumericEditor.Close(); })
            .SetOnYesClick(function (val) {
            _this.props.data.doSetGameFreeSpinBet({
                gameprovider_gameset_game_id: rec.key_uid,
                app_currency_id: _this.props.currencyId
            }, val);
        }).Show();
    };
    GameSetGamesList.prototype.doSetFreeSpinDenomination = function (rec) {
        var _this = this;
        this.props.dlgNumericEditor
            .SetTitle("Изменить деноминацию")
            .SetDigitsCountValue(2)
            .SetInputCaption("Деноминация")
            .SetInputPlaceHolder("Введите значение деноминации")
            .SetMaxValue(999)
            .SetMinValue(0)
            .SetValue(rec.fs_denom)
            .SetOnCloseClick(function () { _this.props.dlgNumericEditor.Close(); })
            .SetOnYesClick(function (val) {
            _this.props.data.doSetGameFreeSpinDenomination({
                gameprovider_gameset_game_id: rec.key_uid,
                app_currency_id: _this.props.currencyId
            }, val);
        }).Show();
    };
    GameSetGamesList.prototype.isFSEditDisabled = function (record) {
        if (this.props.currencyId <= 0) {
            return true;
        }
        if (this.props.allCurrency) {
            return true;
        }
        if (record.key_uid <= 0) {
            return true;
        }
        if (!record.is_allowed) {
            return true;
        }
        return false;
    };
    GameSetGamesList.prototype.getColumns = function () {
        var _this = this;
        var _title_filter = this.state.searchTitleFilter;
        return [
            {
                title: 'Параметры игр для набора',
                key: "tk-gm-param",
                children: [{
                        title: 'Использовать',
                        key: this.props.data.dk_game_icon_full_url,
                        dataIndex: this.props.data.dk_game_icon_full_url,
                        align: "center",
                        render: function (text, record, idx) {
                            var hintVal = "Использовать";
                            if (record.is_allowed) {
                                hintVal = "Не использовать";
                            }
                            return (React.createElement(WrapTableActions_1.default, null,
                                React.createElement(TableCheckActionIconSelect_1.default, { selected: record.is_allowed, hint: hintVal, onClick: function () { _this.DoAllowGame(record); }, icon: "heart" })));
                        },
                        width: 150,
                        filters: [
                            { text: "Использовать", value: 'true' },
                            { text: "Не использовать", value: 'false' },
                        ],
                        filterMultiple: false,
                        onFilter: function (value, record) { return record.is_allowed === (value === 'true'); },
                        sorter: function (a, b) { return UIUtils_1.UIUtils.bool2Int(a.is_allowed) - UIUtils_1.UIUtils.bool2Int(b.is_allowed); },
                    }, {
                        title: 'Название',
                        dataIndex: this.props.data.dk_game_title,
                        key: this.props.data.dk_game_title,
                        width: 200,
                        filterDropdown: function () { return (React.createElement("div", { className: "custom-filter-dropdown" },
                            React.createElement(antd_1.Input, { ref: function (ele) { return _this.searchTitleInput = ele; }, placeholder: "\u041F\u043E\u0438\u0441\u043A \u043F\u043E \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044E", value: _this.state.searchTitleValue, onChange: _this.onChangeTitleFilter.bind(_this), onPressEnter: function () { _this.onConfirmTitleFilter(); } }),
                            React.createElement(antd_1.Button, { type: "primary", onClick: function () { _this.onConfirmTitleFilter(); } }, "\u041F\u043E\u0438\u0441\u043A"),
                            React.createElement(antd_1.Button, { onClick: _this.onClearTitleFilter.bind(_this) }, "\u0421\u0431\u0440\u043E\u0441"))); },
                        filteredValue: _title_filter,
                        filterIcon: function (filtered) { return React.createElement(antd_1.Icon, { type: "search", style: { color: filtered ? '#E84657' : '#AAAAAA' } }); },
                        onFilter: function (value, record) { return record.game_title.toLowerCase().includes(value.toLowerCase()); },
                        onFilterDropdownVisibleChange: function (visible) {
                            if (visible) {
                                setTimeout(function () {
                                    _this.searchTitleInput.focus();
                                });
                            }
                        },
                        sorter: function (a, b) { return a.game_title.localeCompare(b.game_title); }
                    }, {
                        title: 'Провайдер',
                        dataIndex: this.props.data.dk_game_group_title,
                        key: this.props.data.dk_game_group_title,
                        filters: this.state.filters,
                        filterMultiple: true,
                        onFilter: function (value, record) { return record.game_group_title.includes(value); },
                        width: 200,
                    }, {
                        title: 'Кол-во линий',
                        dataIndex: this.props.data.dk_game_lines_count,
                        key: this.props.data.dk_game_lines_count,
                        sorter: function (a, b) { return a.game_lines_count - b.game_lines_count; },
                        width: 200,
                    }, {
                        title: 'Приоритет',
                        key: this.props.data.dk_priority,
                        align: "center",
                        render: function (text, record, idx) {
                            var _disabled = !record.is_allowed;
                            var _borderColor = "#000000";
                            var _view = "" + record.priority;
                            if (_disabled) {
                                _borderColor = "#808080";
                                _view = "нет";
                            }
                            return (React.createElement(WrapTableActions_1.default, null,
                                React.createElement(TableActionMinus_1.default, { disabled: _disabled, hint: "Понизить", onClick: function () { _this.DoDownOrder(record); } }),
                                React.createElement("div", { style: { minWidth: "50px", borderStyle: "solid", borderRadius: 1, borderWidth: 1, borderColor: "" + _borderColor } },
                                    " ",
                                    _view,
                                    " "),
                                React.createElement(TableActionPlus_1.default, { disabled: _disabled, hint: "Повысить", onClick: function () { _this.DoUpOrder(record); } })));
                        },
                        sorter: function (a, b) { return a.priority - b.priority; },
                        width: 200
                    }]
            }, {
                title: 'Параметры фриспинов для бонусов',
                key: "tk-fs-param",
                children: [
                    {
                        title: 'Общая ставка',
                        dataIndex: this.props.data.dk_fs_tbet,
                        key: this.props.data.dk_fs_mult,
                        sorter: function (a, b) { return a.fs_tbet - b.fs_tbet; },
                        render: function (text, record, idx) {
                            return (React.createElement("div", null, record.fs_tbet.toFixed(2)));
                        },
                        width: 200,
                    }, {
                        title: 'Кол-во линий',
                        key: this.props.data.dk_fs_lines,
                        dataIndex: this.props.data.dk_fs_lines,
                        align: "center",
                        render: function (text, record, idx) {
                            var _disabled = !record.is_allowed;
                            var _borderColor = "#000000";
                            var _view = "" + record.fs_lines;
                            if (_disabled) {
                                _borderColor = "#808080";
                                _view = "нет";
                            }
                            return (React.createElement(WrapTableActions_1.default, null,
                                React.createElement("div", { style: { minWidth: "70px", borderStyle: "solid", borderRadius: 1, borderWidth: 1, borderColor: "" + _borderColor } },
                                    " ",
                                    _view,
                                    " "),
                                React.createElement(TableActionEdit_1.default, { square: true, disabled: _this.isFSEditDisabled(record), hint: "Изменить", onClick: function () { _this.doSetFreeSpinLines(record); } })));
                        },
                        sorter: function (a, b) { return a.fs_lines - b.fs_lines; },
                        width: 200
                    }, {
                        title: 'Ставка на линию',
                        key: this.props.data.dk_fs_bet,
                        dataIndex: this.props.data.dk_fs_bet,
                        align: "center",
                        render: function (text, record, idx) {
                            var _disabled = !record.is_allowed;
                            var _borderColor = "#000000";
                            var _view = "" + record.fs_bet;
                            if (_disabled) {
                                _borderColor = "#808080";
                                _view = "нет";
                            }
                            return (React.createElement(WrapTableActions_1.default, null,
                                React.createElement("div", { style: { minWidth: "70px", borderStyle: "solid", borderRadius: 1, borderWidth: 1, borderColor: "" + _borderColor } },
                                    " ",
                                    _view,
                                    " "),
                                React.createElement(TableActionEdit_1.default, { square: true, disabled: _this.isFSEditDisabled(record), hint: "Изменить", onClick: function () { _this.doSetFreeSpinBet(record); } })));
                        },
                        sorter: function (a, b) { return a.fs_bet - b.fs_bet; },
                        width: 200
                    }, {
                        title: 'Деноминация',
                        key: this.props.data.dk_fs_denom,
                        dataIndex: this.props.data.dk_fs_denom,
                        align: "center",
                        render: function (text, record, idx) {
                            var _disabled = !record.is_allowed;
                            var _borderColor = "#000000";
                            var _view = "" + record.fs_denom;
                            if (_disabled) {
                                _borderColor = "#808080";
                                _view = "нет";
                            }
                            return (React.createElement(WrapTableActions_1.default, null,
                                React.createElement("div", { style: { minWidth: "70px", borderStyle: "solid", borderRadius: 1, borderWidth: 1, borderColor: "" + _borderColor } },
                                    " ",
                                    _view,
                                    " "),
                                React.createElement(TableActionEdit_1.default, { square: true, disabled: _this.isFSEditDisabled(record), hint: "Изменить", onClick: function () { _this.doSetFreeSpinDenomination(record); } })));
                        },
                        sorter: function (a, b) { return a.fs_denom - b.fs_denom; },
                        width: 200
                    }, {
                        title: 'Действия',
                        key: 'action',
                        align: "center",
                        render: function (text, record, idx) { return (React.createElement(WrapTableActions_1.default, null,
                            React.createElement(TableActionConfig_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u044B", onClick: function () { _this.onConfigGameSetClick(record); }, disabled: _this.isFSEditDisabled(record) }),
                            React.createElement(TableActionRobot_1.default, { hint: "\u041D\u0430\u0441\u0442\u0440\u043E\u0438\u0442\u044C \u0432\u044B\u0438\u0433\u0440\u044B\u0448\u0438", onClick: function () { _this.onRobotWinnersConfigClick(record); }, disabled: _this.isFSEditDisabled(record) }))); },
                        width: 150
                    }
                ]
            }
        ];
    };
    GameSetGamesList.prototype.onRobotWinnersConfigClick = function (record) {
        if (this.props.onRobotWinnerConfigClick) {
            this.props.onRobotWinnerConfigClick(record);
        }
    };
    GameSetGamesList.prototype.onConfigGameSetClick = function (record) {
        var _this = this;
        if (record.key_uid == 0) {
            notificationHelper_1.default.ShowTextTopRightErrorNotify("Игра не выбрана или некорректна!");
            return;
        }
        this.props.data.doGetGameFreeSpinDetails({
            gameprovider_gameset_game_id: record.key_uid,
            app_currency_id: this.props.currencyId
        }, function (lines, bets, dnms) {
            _this.props.dlgGameEdit
                .SetBetVal(0)
                .SetLineNum(0)
                .SetDnmVal(0)
                .SetBets(bets)
                .SetLines(lines)
                .SetDnms(dnms)
                .SetDialogTitle("\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u043E\u0432 \u0438\u0433\u0440\u044B [" + record.game_title + "]")
                .SetOnYesClick(function (line, bet, dnm) {
                _this.props.data.doSetGameFreeSpinLineBetDenom({
                    app_currency_id: _this.props.currencyId,
                    gameprovider_gameset_game_id: record.key_uid
                }, line, bet, dnm, function () {
                    notificationHelper_1.default.ShowBottomRightNotificationText("\u041D\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u0444\u0440\u0438\u0441\u043F\u0438\u043D\u043E\u0432 \u0434\u043B\u044F \u0438\u0433\u0440\u044B [" + record.game_title + "] \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B!");
                });
                _this.props.dlgGameEdit.Close();
            })
                .Show();
        });
        /*if (this.props.onConfigClick) {
            this.props.onConfigClick(record);
        }*/
    };
    GameSetGamesList.prototype.onToolBarClick = function (action) {
        var _this = this;
        if (action === "refresh") {
            this.setState({ loading: true }, function () {
                _this.props.data.LoadData(_this.props.record.key, _this.props.allCurrency, _this.props.currencyId);
            });
        }
        if (action === "back") {
            if (this.props.onGoBackClick) {
                this.props.onGoBackClick();
            }
        }
    };
    GameSetGamesList.prototype.doAllowAllGames = function () {
        var _this = this;
        this.props.data.SetAllGameTemplatesIsAllowed(this.props.record.key, function () {
            _this.props.data.LoadData(_this.props.record.key, _this.props.allCurrency, _this.props.currencyId, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0412\u0441\u0435 \u0438\u0433\u0440\u044B \u0432 \u043D\u0430\u0431\u043E\u0440\u0435 \u0431\u044B\u043B\u0438 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B"));
            });
        });
    };
    GameSetGamesList.prototype.doRejectAllGames = function () {
        var _this = this;
        this.props.data.SetAllGameTemplatesIsRejected(this.props.record.key, function () {
            _this.props.data.LoadData(_this.props.record.key, _this.props.allCurrency, _this.props.currencyId, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u0412\u0441\u0435 \u0438\u0433\u0440\u044B \u0432 \u043D\u0430\u0431\u043E\u0440\u0435 \u0431\u044B\u043B\u0438 \u043E\u0442\u043A\u043B\u044E\u0447\u0435\u043D\u044B"));
            });
        });
    };
    GameSetGamesList.prototype.onCurrencyFilterChanged = function (allCurrencies, CurrencyId) {
        var _this = this;
        this.props.data.LoadData(this.props.record.key, allCurrencies, CurrencyId, function () {
            if (_this.props.onCurrencyFilterChanged) {
                _this.props.onCurrencyFilterChanged(allCurrencies, CurrencyId);
            }
        });
    };
    GameSetGamesList.prototype.doSetAllFreeSpinTotalBet = function () {
        var _this = this;
        this.props.dlgNumericEditor
            .SetTitle("Установить значение общей ставки фриспинов")
            .SetDigitsCountValue(2)
            .SetInputCaption("Общ. Ставка")
            .SetInputPlaceHolder("Введите значение общей ставки")
            .SetMaxValue(999)
            .SetMinValue(0)
            .SetValue(0)
            .SetOnCloseClick(function () { _this.props.dlgNumericEditor.Close(); })
            .SetOnYesClick(function (val) {
            _this.props.data.SetAllGameSetGamesFreeSpinBetLineDenom(_this.props.record.key, _this.props.currencyId, val, function () {
                notificationHelper_1.default.ShowTopRightNotification(React.createElement("div", null, "\u041E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u0435 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0441\u0442\u0430\u0432\u043A\u0438 \u0431\u044B\u043B\u0438 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B"));
            });
        }).Show();
    };
    GameSetGamesList.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", null,
            React.createElement(ToolBarButtonsOnly_1.default, { hint: { back: "Вернуться", refresh: "Обновить" }, onClick: this.onToolBarClick.bind(this) },
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: "Включить все игры ?", okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.doAllowAllGames.bind(this) },
                    React.createElement(ButtonLockUnLockAll_1.default, { hint: "Включить все игры", onClick: function () { } })),
                React.createElement(antd_1.Popconfirm, { placement: "bottom", title: "Отключить все игры ?", okText: "\u0414\u0430", cancelText: "\u041D\u0435\u0442", onConfirm: this.doRejectAllGames.bind(this) },
                    React.createElement(ButtonLockLockAll_1.default, { hint: "Отключить все игры", onClick: function () { } })),
                React.createElement(ButtonDoCalc_1.default, { disabled: this.props.currencyId == 0, hint: "Установить ставку для фриспинов ", onClick: this.doSetAllFreeSpinTotalBet.bind(this) }),
                React.createElement(ToolBarComboBoxFilter_1.default, { allItems: this.props.allCurrency, availItems: this.props.availCurrency, captions: { checkbox: "Все валюты", placeholder: "Выберите валюту" }, selectedItem: this.props.currencyId, onFilterChanged: this.onCurrencyFilterChanged.bind(this), width: "100%" })),
            React.createElement(antd_1.Table, { rowKey: "key", locale: {
                    filterTitle: 'Поиск',
                    filterConfirm: 'Да',
                    filterReset: 'Сброс',
                    emptyText: 'Нет данных',
                }, bordered: true, columns: this.getColumns(), dataSource: this.state.data, loading: this.state.loading, pagination: {
                    defaultPageSize: this.props.state.UITablePageSize,
                    showSizeChanger: true,
                    position: "bottom",
                    pageSizeOptions: this.props.state.UITablePageSizeOptions,
                    showQuickJumper: true,
                }, footer: function (data) {
                    return React.createElement("div", null,
                        "\u041E\u0442\u043E\u0431\u0440\u0430\u0436\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0441\u0442\u0440\u0430\u043D\u0438\u0446\u0435 :  ",
                        _this.state.totalRows,
                        " \u0437\u0430\u043F\u0438\u0441\u0435\u0439");
                }, expandedRowRender: function (record) { return (React.createElement("div", { style: { margin: 0, display: "flex", flexDirection: "row", flexWrap: "nowrap" } },
                    React.createElement("div", { key: "t_1", style: { display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", flexWrap: "nowrap" } },
                        React.createElement("div", { key: "c_1" },
                            React.createElement("b", null, "\u0418\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0442\u043E\u0440 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.key_uid,
                            "]"),
                        React.createElement("div", { key: "c_2" },
                            React.createElement("b", null, "\u0411\u044D\u043A\u0435\u043D\u0434 \u043A\u043E\u0434 \u0437\u0430\u043F\u0438\u0441\u0438:"),
                            " [",
                            record.game_backend_code,
                            "]"),
                        React.createElement("div", { key: "c_3" },
                            React.createElement("b", null, "\u041B\u0438\u043D\u0438\u0439:"),
                            " [",
                            record.game_lines_count,
                            "]"),
                        React.createElement("div", { key: "c_4" },
                            React.createElement("b", null, "Url:"),
                            " [",
                            record.game_icon_full_url,
                            "]")),
                    React.createElement("div", { key: "t_2" },
                        React.createElement("img", { style: { marginLeft: "20px" }, height: 110, src: record.game_icon_full_url })))); }, scroll: { x: true } })));
    };
    return GameSetGamesList;
}(React.Component));
exports.default = GameSetGamesList;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/GameSetGamesList.tsx
// module id = 2001
// module chunks = 0